var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeamIconDarkblue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7766 17.8673C14.1568 17.4655 14.5968 17.1214 15.083 16.8483C15.9086 16.3845 16.8396 16.1409 17.7866 16.1409C18.7335 16.1409 19.6646 16.3845 20.4902 16.8483C20.8473 17.0489 21.1795 17.2877 21.4814 17.5598M15.2641 22.489C15.0935 20.4461 14.5844 19.1028 14.3053 18.6298C13.7111 17.6196 12.876 16.7846 11.8803 16.2052C10.8845 15.6257 9.76161 15.3214 8.6195 15.3214C7.47739 15.3214 6.3545 15.6257 5.35874 16.2052C4.56363 16.6678 3.87094 17.2934 3.32153 18.0411L2.97322 18.5625M17.7866 13.607C16.2622 13.607 15.0265 12.3713 15.0265 10.8469C15.0265 9.32253 16.2622 8.08678 17.7866 8.08678C19.3109 8.08678 20.5467 9.32253 20.5467 10.8469C20.5467 12.3713 19.3109 13.607 17.7866 13.607ZM8.85675 12.7213C6.96778 12.7213 5.43645 11.19 5.43645 9.30103C5.43645 7.41204 6.96778 5.88072 8.85675 5.88072C10.7457 5.88072 12.2771 7.41204 12.2771 9.30103C12.2771 11.19 10.7457 12.7213 8.85675 12.7213ZM11.8929 23.0357C5.73883 23.0357 0.75 18.047 0.75 11.8929C0.75 5.73883 5.73883 0.75 11.8929 0.75C18.047 0.75 23.0357 5.73883 23.0357 11.8929C23.0357 18.047 18.047 23.0357 11.8929 23.0357Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIconDarkblue);
export default __webpack_public_path__ + "static/media/team-icon-darkblue.777ce0f2.svg";
export { ForwardRef as ReactComponent };